import styled from "styled-components";
import { NotificationContainer } from "./common.styles";

export const UploadErrorNotification = styled(NotificationContainer as any)`
  background-color: ${(p) => p.theme.palette.error.main};
`;
